import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { SIG_SAMPLES } from "./signingSamples";

export const CodeSamples = () => {
    const langs = Object.keys(SIG_SAMPLES);
    const [lang, setLang] = useState(langs[0]);
    const [copied, setCopied] = useState(false);
    const copy = () => {
        navigator.clipboard?.writeText(SIG_SAMPLES[lang]);
        setCopied(true); setTimeout(() => setCopied(false), 1500);
    };
    return (
        <div className="border border-slate-200 rounded-lg overflow-hidden" data-testid="wh-sign-samples">
            <div className="flex items-center justify-between bg-slate-50 border-b border-slate-200 px-2">
                <div className="flex">
                    {langs.map((l) => (
                        <button key={l} type="button" onClick={() => setLang(l)} data-testid={`wh-sign-lang-${l.replace(/\W/g, "").toLowerCase()}`}
                                className={`px-3 py-2 text-xs font-medium border-b-2 transition-colors ${lang === l ? "border-indigo-600 text-indigo-700" : "border-transparent text-slate-500 hover:text-slate-800"}`}>
                            {l}
                        </button>
                    ))}
                </div>
                <button type="button" onClick={copy} data-testid="wh-sign-copy-code"
                        className="text-xs text-slate-500 hover:text-slate-800 flex items-center gap-1 px-2">
                    {copied ? <Check className="w-3.5 h-3.5 text-emerald-600" /> : <Copy className="w-3.5 h-3.5" />} {copied ? "Copied" : "Copy"}
                </button>
            </div>
            <pre data-testid="wh-sign-code" className="bg-slate-950 text-slate-100 text-[11.5px] leading-relaxed p-4 overflow-x-auto max-h-[420px]"><code>{SIG_SAMPLES[lang]}</code></pre>
        </div>
    );
};
